import { useState } from 'react';

const mediaItems = [
  {
    tag: '热播剧集',
    title: '暑期档古装大剧《长安幻夜》',
    desc: '权谋与爱情交织，画面绝美，口碑持续走高',
    imgUrl: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20style%2C%20elegant%20traditional%20costume%20silhouette%20against%20warm%20sunset%2C%20cinematic%20lighting%2C%20soft%20focus%2C%20artistic%20composition%2C%20golden%20hour%20tones%2C%20moody%20atmosphere%2C%20high%20production%20value&width=600&height=800&seq=media-card-01&orientation=portrait',
  },
  {
    tag: '悬疑剧场',
    title: '高分悬疑新作《迷雾追踪》',
    desc: '烧脑反转不断，弹幕刷屏的年度必看',
    imgUrl: 'https://readdy.ai/api/search-image?query=Modern%20suspense%20thriller%20visual%2C%20urban%20nightscape%20with%20neon%20reflections%2C%20mysterious%20atmosphere%2C%20cool%20blue%20and%20warm%20amber%20contrast%2C%20cinematic%20wide%20shot%2C%20high%20production%20value%2C%20dramatic%20lighting&width=600&height=800&seq=media-card-02&orientation=portrait',
  },
  {
    tag: '院线新片',
    title: '科幻巨制《星际远征》',
    desc: '震撼视效，上映首周票房破5亿',
    imgUrl: 'https://readdy.ai/api/search-image?query=Sci-fi%20epic%20visual%2C%20futuristic%20cityscape%20with%20warm%20orange%20sky%2C%20dramatic%20scale%2C%20atmospheric%20haze%2C%20cinematic%20composition%2C%20epic%20scope%2C%20grand%20spacecraft%20silhouettes%2C%20emotional%20depth&width=600&height=800&seq=media-card-03&orientation=portrait',
  },
  {
    tag: '综艺热播',
    title: '《声入人心》全新一季',
    desc: '神仙打架级舞台，每一期都值得回味',
    imgUrl: 'https://readdy.ai/api/search-image?query=Music%20performance%20stage%20with%20dramatic%20spotlight%20and%20atmospheric%20fog%2C%20elegant%20concert%20setting%2C%20warm%20golden%20and%20deep%20blue%20contrast%2C%20artistic%20photography%2C%20emotional%20moment%2C%20high%20detail&width=600&height=800&seq=media-card-04&orientation=portrait',
  },
  {
    tag: '口碑推荐',
    title: '纪录片《山海之间》',
    desc: '豆瓣9.2分，自然与人文的诗意对话',
    imgUrl: 'https://readdy.ai/api/search-image?query=Natural%20landscape%20with%20soft%20morning%20light%2C%20mountain%20and%20sea%20horizon%2C%20contemplative%20mood%2C%20earthy%20tones%2C%20wide%20composition%2C%20meditative%20atmosphere%2C%20documentary%20aesthetic%2C%20serene%20beauty&width=600&height=800&seq=media-card-05&orientation=portrait',
  },
];

function MediaCard({ item }: { item: typeof mediaItems[0] }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300">
      <div className="relative aspect-[3/4] overflow-hidden">
        {!imgError ? (
          <img
            src={item.imgUrl}
            alt={item.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full bg-background-200 flex items-center justify-center">
            <i className="ri-image-line text-4xl text-foreground-300"></i>
          </div>
        )}
        <div className="absolute top-3 left-3">
          <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
            {item.tag}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5 line-clamp-1">
          {item.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {item.desc}
        </p>
      </div>
    </div>
  );
}

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            精彩抢先看
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            最新电视剧更新、热门电影上映、综艺在线 — 你想追的都在这里
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <MediaCard key={idx} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}